import React from "react";
import InfoSection from "@components/pages/info/info_section";
import ServiceHeader from "@components/pages/info/services/service_header";
import Head from "next/head";
import { LOGIN_PATH, THEME_COLOR_SECONDARY, WEBPAGE_TITLE } from "@utils/constants";

function GuideSimaskra() {
    return (
        <>
            <Head>
                <title key="site_title">Skráning í símaskrá - {WEBPAGE_TITLE}</title>
                <meta
                    name="description"
                    content="Leiðbeiningar um hvernig skrá sig í símaskrá hjá 1819."
                    key="description"
                />
            </Head>
            <InfoSection containerStyle={{ padding: 30 }}>
                <ServiceHeader title="Skráning í símaskrá" />

                <p style={{ fontWeight: 600 }}>
                    Hér fyrir neðan eru leiðbeiningar um hvernig þú getur skráð þig í símaskrá 1819.
                </p>

                <div className="row" style={{ marginTop: 10 }}>
                    <div className="col-md-12">
                        <ol style={{ paddingLeft: 20, marginTop: 10 }}>
                            <li style={{ marginTop: "30px" }}>
                                Smelltu á Mitt 1819 hér fyrir ofan, eða smelltu{" "}
                                <a href={LOGIN_PATH} style={{ textDecoration: "underline" }}>
                                    hér
                                </a>
                                .
                            </li>
                            <img
                                src="/img/skraning-i-simaskra/9.png"
                                alt="Skráning í símaskrá"
                                style={{
                                    display: "block",
                                    margin: "0 auto",
                                    maxWidth: "100%",
                                    width: "600px",
                                    maxHeight: "400px",
                                    objectFit: "contain",
                                    marginTop: "10px",
                                    marginBottom: "10px",
                                }}
                            />
                            <li style={{ marginTop: "30px" }}>
                                Skráðu þig inn með rafrænum skilríkjum eða Auðkennisappinu.
                            </li>
                            <img
                                src="/img/skraning-i-simaskra/11.png"
                                alt="Skráning í símaskrá"
                                style={{
                                    display: "block",
                                    margin: "0 auto",
                                    maxWidth: "100%",
                                    width: "600px",
                                    maxHeight: "400px",
                                    objectFit: "contain",
                                    marginTop: "10px",
                                    marginBottom: "10px",
                                }}
                            />
                            <li style={{ marginTop: "30px" }}>
                                Samþykktu skilmálana sem koma upp, ef þú hefur ekki gert það áður.
                            </li>
                            <img
                                src="/img/skraning-i-simaskra/10.png"
                                alt="Skráning í símaskrá"
                                style={{
                                    display: "block",
                                    margin: "0 auto",
                                    maxWidth: "100%",
                                    width: "600px",
                                    maxHeight: "400px",
                                    objectFit: "contain",
                                    marginTop: "10px",
                                    marginBottom: "10px",
                                }}
                            />
                            <li style={{ marginTop: "30px" }}>
                                Undir „Flýtileiðir“, smelltu á „Mín skráning“. Þú getur líka smellt
                                á „Skráning hjá 1819“ vinstra megin.
                            </li>
                            <img
                                src="/img/skraning-i-simaskra/0.png"
                                alt="Skráning í símaskrá"
                                style={{
                                    display: "block",
                                    margin: "0 auto",
                                    maxWidth: "100%",
                                    width: "600px",
                                    maxHeight: "400px",
                                    objectFit: "contain",
                                    marginTop: "10px",
                                    marginBottom: "10px",
                                }}
                            />
                            <li style={{ marginTop: "30px" }}>
                                Hér opnast þín skráning, en hér getur þú sett inn starfsheiti.
                            </li>
                            <img
                                src="/img/skraning-i-simaskra/1.png"
                                alt="Skráning í símaskrá"
                                style={{
                                    display: "block",
                                    margin: "0 auto",
                                    maxWidth: "100%",
                                    width: "600px",
                                    maxHeight: "400px",
                                    objectFit: "contain",
                                    marginTop: "10px",
                                    marginBottom: "10px",
                                }}
                            />
                            <li style={{ marginTop: "30px" }}>
                                Ef heimilisfangið er ekki rétt, getur þú breytt því með því að
                                afhaka „Birta samkvæmt Þjóðskrá“. Þú getur líka valið að fela
                                heimilisfangið þitt með því að afhaka „Sýna heimilisfang“.
                                <br />
                                Ef heimilisfangið er ekki á réttum stað á kortinu, getur þú smellt á
                                kortið til að breyta staðsetningunni.
                            </li>
                            <img
                                src="/img/skraning-i-simaskra/2.png"
                                alt="Skráning í símaskrá"
                                style={{
                                    display: "block",
                                    margin: "0 auto",
                                    maxWidth: "100%",
                                    width: "600px",
                                    maxHeight: "400px",
                                    objectFit: "contain",
                                    marginTop: "10px",
                                    marginBottom: "10px",
                                }}
                            />
                            <li style={{ marginTop: "30px" }}>
                                Hér setur þú inn símanúmer sem eiga að vera í símaskrá. Hægt er að
                                bannmerkja númerin og fela.
                                <br />
                                ATH. Þó svo að símanúmerið sé falið, þá er hægt að leita að númerinu
                                í leitarvél 1819.is. Einnig geta sveitarfélög sent mikilvægar
                                upplýsingar með SMS skilaboðum á þau númer sem eru falin.
                            </li>
                            <img
                                src="/img/skraning-i-simaskra/3.png"
                                alt="Skráning í símaskrá"
                                style={{
                                    display: "block",
                                    margin: "0 auto",
                                    maxWidth: "100%",
                                    width: "600px",
                                    maxHeight: "400px",
                                    objectFit: "contain",
                                    marginTop: "10px",
                                    marginBottom: "10px",
                                }}
                            />
                            <li style={{ marginTop: "30px" }}>
                                Hér getur þú sett inn netfangið þitt og vefsíðu ef þú vilt að hún
                                birtist í símaskrá.
                            </li>
                            <img
                                src="/img/skraning-i-simaskra/4.png"
                                alt="Skráning í símaskrá"
                                style={{
                                    display: "block",
                                    margin: "0 auto",
                                    maxWidth: "100%",
                                    width: "600px",
                                    maxHeight: "400px",
                                    objectFit: "contain",
                                    marginTop: "10px",
                                    marginBottom: "10px",
                                }}
                            />
                            <li style={{ marginTop: "30px" }}>
                                Hér getur þú valið að setja inn samfélagsmiðlana þína, Facebook, X
                                (Twitter), Instagram, LinkedIn.
                            </li>
                            <img
                                src="/img/skraning-i-simaskra/5.png"
                                alt="Skráning í símaskrá"
                                style={{
                                    display: "block",
                                    margin: "0 auto",
                                    maxWidth: "100%",
                                    width: "600px",
                                    maxHeight: "400px",
                                    objectFit: "contain",
                                    marginTop: "10px",
                                    marginBottom: "10px",
                                }}
                            />
                            <li style={{ marginTop: "30px" }}>
                                Hér getur þú sett inn nánari upplýsingar um þig.
                            </li>
                            <img
                                src="/img/skraning-i-simaskra/6.png"
                                alt="Skráning í símaskrá"
                                style={{
                                    display: "block",
                                    margin: "0 auto",
                                    maxWidth: "100%",
                                    width: "600px",
                                    maxHeight: "400px",
                                    objectFit: "contain",
                                    marginTop: "10px",
                                    marginBottom: "10px",
                                }}
                            />
                            <li style={{ marginTop: "30px" }}>
                                Hægra megin á síðunni má sjá forskoðun á því hvernig skráningin þín
                                mun líta út á 1819.is.
                            </li>
                            <img
                                src="/img/skraning-i-simaskra/8.png"
                                alt="Skráning í símaskrá"
                                style={{
                                    display: "block",
                                    margin: "0 auto",
                                    maxWidth: "100%",
                                    width: "600px",
                                    maxHeight: "400px",
                                    objectFit: "contain",
                                    marginTop: "10px",
                                    marginBottom: "10px",
                                }}
                            />

                            <li style={{ marginTop: "30px" }}>
                                Þegar þú hefur sett inn allar upplýsingar sem þú vilt að birtist í
                                símaskrá, smellir þú á „Stofna“.
                            </li>
                            <img
                                src="/img/skraning-i-simaskra/7.png"
                                alt="Skráning í símaskrá"
                                style={{
                                    display: "block",
                                    margin: "0 auto",
                                    maxWidth: "100%",
                                    width: "600px",
                                    maxHeight: "400px",
                                    objectFit: "contain",
                                    marginTop: "10px",
                                    marginBottom: "10px",
                                }}
                            />
                        </ol>
                    </div>
                </div>

                <div style={{ marginTop: 10 }}>
                    Hefurðu einhverjar spurningar? Hafðu samband við okkur með því að smella á
                    takkann hér að neðan.
                </div>

                <p style={{ textAlign: "center", marginTop: 20 }}>
                    <a className="btn btn-primary" href="/um/fyrirtaekid/hafa-samband">
                        Hafa samband
                    </a>
                </p>
            </InfoSection>
        </>
    );
}

export default GuideSimaskra;
